// This SDK supports both Next.js Pages Router and App Router.
// 'use client' is required for App Router compatibility; it is a no-op in Pages Router.
'use client'

import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query'

export function useHttpQuery<TQueryFnData = unknown, TData = TQueryFnData, TError = Error>(
  options: UseQueryOptions<TQueryFnData, TError, TData>,
): UseQueryResult<TData, TError> {
  return useQuery<TQueryFnData, TError, TData>(options)
}
